import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-location",
  "use": "icon-icon-location-usage",
  "viewBox": "0 0 28 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 32\" id=\"icon-icon-location\"><path clip-rule=\"evenodd\" d=\"M14 32s14-8.649 14-18.162C28 6.195 21.732 0 14 0S0 6.195 0 13.838C0 23.35 14 32 14 32zm0-13.351a5 5 0 1 0 0-10 5 5 0 0 0 0 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol